<template>
    <header class="flex px-4 pt-3 sm:px-0 sm:pt-0 justify-between items-center">
        <h1
            class="py-8 md:py-14 xl:py-19 text-2xl md:text-3xl xl:text-4xl font-title text-brand-500 font-semibold"
        >
            {{ name }}
        </h1>
        <illustration-svg
            v-if="illuName"
            :illu-name="name"
            :color-mode="colorMode"
            class="max-h-24 md:max-h-36 xl:max-h-48"
        />
    </header>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import { useStore } from 'vuex'

import IllustrationSvg from '@/common/components/ui/IllustrationSvg.vue'

export default defineComponent({
    name: 'TheMainHeader',
    components: {
        IllustrationSvg,
    },
    props: {
        name: {
            type: String,
            required: true,
        },
        illuName: {
            type: String,
        },
    },
    setup(props) {
        const store = useStore()

        const nameToLowerCase = computed(() => props.name.toLowerCase())
        const colorMode = computed(() => store.getters['ui/colorMode'])

        return {
            nameToLowerCase,
            colorMode,
        }
    },
})
</script>
